const productList = [
  {
    productId: "1",
    productName: "Solo English",
    productImgUrl: "Product_Illustrations/learnship-solo.svg",
    productDescription: "product_solo_desc",
    productBtnText: "button_GetStarted",
    productCourseBtnText: "button_Resume",
    productCertificateBtnText: "button_ViewDetails",
    productContinueStudyingBtnText: "button_ContinueStudying",
  },
  {
    productId: "4",
    productName: "One Coach(Not in use)",
    productImgUrl: "Product_Illustrations/learnship-coach.svg",
    productDescription: "product_Lorem_desc",
    productBtnText: "button_GetStarted",
    productCourseBtnText: "button_Resume",
    productCertificateBtnText: "button_ViewDetails",
    productContinueStudyingBtnText: "button_ContinueStudying",
  },
  {
    productId: "5",
    productName: "STEP(baseline)",
    productImgUrl: "Product_Illustrations/learnship-baseline.svg",
    productDescription: "product_Lorem_desc",
    productBtnText: "button_GetStarted",
    productCourseBtnText: "button_Resume",
    productCertificateBtnText: "button_ViewDetails",
    productContinueStudyingBtnText: "button_ContinueStudying",
  },
  {
    productId: "6",
    productName: "STEP+(baseline+)",
    productImgUrl: "Product_Illustrations/learnship-baseline.svg",
    productDescription: "product_Lorem_desc",
    productBtnText: "button_GetStarted",
    productCourseBtnText: "button_Resume",
    productCertificateBtnText: "button_ViewDetails",
    productContinueStudyingBtnText: "button_ContinueStudying",
  },
  {
    productId: "14",
    productName: "Solo Premium",
    productImgUrl: "Product_Illustrations/learnship-solo.svg",
    productDescription: "product_Lorem_desc",
    productBtnText: "button_GetStarted",
    productCourseBtnText: "button_Resume",
    productCertificateBtnText: "button_ViewDetails",
    productContinueStudyingBtnText: "button_ContinueStudying",
  },
  {
    productId: "15",
    productName: "Reach",
    productImgUrl: "Product_Illustrations/learnship-elevate.svg",
    productDescription: "product_reach_desc",
    productBtnText: "Go",
    productCourseBtnText: "button_Resume",
    productCertificateBtnText: "button_ViewDetails",
    productContinueStudyingBtnText: "button_ContinueStudying",
  },
  {
    productId: "17",
    productName: "Solo Platinum",
    productImgUrl: "Product_Illustrations/solo-conversation-practice.svg",
    productDescription: "product_conversationPractice_desc",
    productBtnText: "button_GetStarted",
    productCourseBtnText: "button_Resume",
    productCertificateBtnText: "button_ViewDetails",
    productContinueStudyingBtnText: "button_ContinueStudying",
  },
  {
    productId: "18",
    productName: "Sprint Business Skills",
    productImgUrl: "Product_Illustrations/sprint-business-skills.svg",
    productDescription: "product_sprint_businessSkills_desc",
    productBtnText: "button_GetStarted",
    productCourseBtnText: "button_Resume",
    productCertificateBtnText: "button_ViewDetails",
    productContinueStudyingBtnText: "button_ContinueStudying",
  },
  {
    productId: "20",
    productName: "Sprint Business English",
    productImgUrl: "Product_Illustrations/Sprint-level-progress.svg",
    productDescription: "product_sprint_levelsProgress_desc",
    productBtnText: "button_GetStarted",
    productCourseBtnText: "button_Resume",
    productCertificateBtnText: "button_ViewDetails",
    productContinueStudyingBtnText: "button_ContinueStudying",
  },
  {
    productId: "26",
    productName: "Sprint Business German",
    productImgUrl: "Product_Illustrations/sprint-business-german.svg",
    productDescription: "product_sprint_business_german_desc",
    productBtnText: "button_GetStarted",
    productCourseBtnText: "button_Resume",
    productCertificateBtnText: "button_ViewDetails",
    productContinueStudyingBtnText: "button_ContinueStudying",
  },
  {
    productId: "27",
    productName: "Sprint Business French",
    productImgUrl: "Product_Illustrations/sprint-business-french.svg",
    productDescription: "product_sprint_business_french_desc",
    productBtnText: "button_GetStarted",
    productCourseBtnText: "button_Resume",
    productCertificateBtnText: "button_ViewDetails",
    productContinueStudyingBtnText: "button_ContinueStudying",
  },
  {
    productId: "28",
    productName: "Sprint Business Spanish",
    productImgUrl: "Product_Illustrations/sprint-business-spanish.svg",
    productDescription: "product_sprint_business_spanish_desc",
    productBtnText: "button_GetStarted",
    productCourseBtnText: "button_Resume",
    productCertificateBtnText: "button_ViewDetails",
    productContinueStudyingBtnText: "button_ContinueStudying",
  },
  {
    productId: "",
    productName: "Relocation Language Training",
    productImgUrl: "Product_Illustrations/evolve-relocation-language.svg",
    productDescription: "product_evolve_relocationLanguage_desc",
    productBtnText: "button_GetStarted",
    productCourseBtnText: "button_Resume",
    productCertificateBtnText: "button_ViewDetails",
    productContinueStudyingBtnText: "button_ContinueStudying",
  },
  {
    productId: "",
    productName: "Business Language Training",
    productImgUrl: "Product_Illustrations/elevate-levels-progress.svg",
    productDescription: "product_elevate_levelsProgress_desc",
    productBtnText: "button_GetStarted",
    productCourseBtnText: "button_Resume",
    productCertificateBtnText: "button_ViewDetails",
    productContinueStudyingBtnText: "button_ContinueStudying",
  },
  {
    productId: "",
    productName: "Business Language coaching",
    productImgUrl: "Product_Illustrations/coach-language-coach.svg",
    productDescription: "product_coach_languageCoach_desc",
    productBtnText: "button_GetStarted",
    productCourseBtnText: "button_Resume",
    productCertificateBtnText: "button_ViewDetails",
    productContinueStudyingBtnText: "button_ContinueStudying",
  },
  {
    productId: "",
    productName: "Business Language Modules",
    productImgUrl: "Product_Illustrations/elevate-business-skills.svg",
    productDescription: "product_elevate_businessSkills_desc",
    productBtnText: "button_GetStarted",
    productCourseBtnText: "button_Resume",
    productCertificateBtnText: "button_ViewDetails",
    productContinueStudyingBtnText: "button_ContinueStudying",
  },
  {
    productId: "",
    productName: "Culture Power Skills",
    productImgUrl: "Product_Illustrations/evolve-culture-skills.svg",
    productDescription: "product_evolve_culturePowerSkills_desc",
    productBtnText: "button_GetStarted",
    productCourseBtnText: "button_Resume",
    productCertificateBtnText: "button_ViewDetails",
    productContinueStudyingBtnText: "button_ContinueStudying",
  },
  {
    productId: "",
    productName: "Culture Change",
    productImgUrl: "Product_Illustrations/evolve-culture-change.svg",
    productDescription: "product_evolve_cultureChange_desc",
    productBtnText: "button_GetStarted",
    productCourseBtnText: "button_Resume",
    productCertificateBtnText: "button_ViewDetails",
    productContinueStudyingBtnText: "button_ContinueStudying",
  },
  {
    productId: "",
    productName: "Culture Focus",
    productImgUrl: "Product_Illustrations/evolve-culture-focus.svg",
    productDescription: "product_evolve_cultureFocus_desc",
    productBtnText: "button_GetStarted",
    productCourseBtnText: "button_Resume",
    productCertificateBtnText: "button_ViewDetails",
    productContinueStudyingBtnText: "button_ContinueStudying",
  },
  {
    productId: "",
    productName: "Culture Coach",
    productImgUrl: "Product_Illustrations/coach-culture-coach.svg",
    productDescription: "product_coach_cultureCoach_desc",
    productBtnText: "button_GetStarted",
    productCourseBtnText: "button_Resume",
    productCertificateBtnText: "button_ViewDetails",
    productContinueStudyingBtnText: "button_ContinueStudying",
  },
  {
    productId: "21",
    productName: "Solo Business English",
    productImgUrl: "Product_Illustrations/solo-business-english.svg",
    productDescription: "product_solo_business_english",
    productBtnText: "button_GetStarted",
    productCourseBtnText: "button_Resume",
    productCertificateBtnText: "button_ViewDetails",
    productContinueStudyingBtnText: "button_ContinueStudying",
  },
  {
    productId: "22",
    productName: "Solo Business German",
    productImgUrl: "Product_Illustrations/solo-business-german.svg",
    productDescription: "product_solo_business_german",
    productBtnText: "button_GetStarted",
    productCourseBtnText: "button_Resume",
    productCertificateBtnText: "button_ViewDetails",
    productContinueStudyingBtnText: "button_ContinueStudying",
  },
  {
    productId: "23",
    productName: "Solo Business French",
    productImgUrl: "Product_Illustrations/solo-business-french.svg",
    productDescription: "product_solo_business_french",
    productBtnText: "button_GetStarted",
    productCourseBtnText: "button_Resume",
    productCertificateBtnText: "button_ViewDetails",
    productContinueStudyingBtnText: "button_ContinueStudying",
  },
  {
    productId: "24",
    productName: "Solo Business Spanish",
    productImgUrl: "Product_Illustrations/solo-business-spanish.svg",
    productDescription: "product_solo_business_spanish",
    productBtnText: "button_GetStarted",
    productCourseBtnText: "button_Resume",
    productCertificateBtnText: "button_ViewDetails",
    productContinueStudyingBtnText: "button_ContinueStudying",
  },
  {
    productId: "25",
    productName: "Elevate Business English",
    productImgUrl: "Product_Illustrations/elevate-business-english.svg",
    productDescription: "Elevate levels progress image",
    productBtnText: "button_GetStarted",
    productCourseBtnText: "button_Resume",
    productCertificateBtnText: "button_ViewDetails",
    productContinueStudyingBtnText: "button_ContinueStudying",
  },
  {
    productId: "13",
    productName: "Learnship Dashboard",
    productImgUrl: "Product_Illustrations/dashboard.svg",
    productDescription: "Learnship Dashboard",
    productBtnText: "button_Go",
    productCourseBtnText: "button_Resume",
    productCertificateBtnText: "button_ViewDetails",
    productContinueStudyingBtnText: "button_ContinueStudying",
  },
];

const monthList = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const tmsProductIds = ["8", "17", "18", "20", "25", "26", "27", "28"];
const allEnglishProductIds = ["1", "2", "3", "4", "7", "6", "8", "11", "12", "14", "17", "18", "20", "21", "25", "26", "27", "28"];
const progressPageIds = ["15", "18", "20", "21", "22", "23", "24", "25", "26", "27", "28"];
const orderedDemoLicensesIds = [
  "1",
  "5",
  "16",
  "17",
  "19",
  "21",
  "22",
  "23",
  "24",
  "20",
  "26",
  "27",
  "28",
  "18",
  "25",
  "6",
  "13",
];
const dynamicCardProducts = ["18", "20", "21", "22", "23", "24", "25", "26", "27", "28"];
const dashboardProductIds = ["0", "56", "57", "58", "59", "60", "61", "61", "63", "64"];
const allProducts = ["18", "20", "21", "22", "23", "24", "25"];
const soloProducts = ["21", "22", "23", "24"];
const sprintBusinessProducts = ["20", "26", "27", "28"];
const soloProductsMapper = ["57", "58", "59", "60"];
const demoLicenseUserId = "1719644";
const LOCALES = [
  { key: "English", val: "EN" },
  { key: "Italiano", val: "IT-IT" },
  { key: "Deutsch", val: "DE-DE" },
  { key: "日本語", val: "JA-JP" },
  { key: "Español (Latinoamérica)", val: "ES-MX" },
  { key: "Português (Brasil)", val: "PT-BR" },
  { key: "中文 简体", val: "ZH-CN" },
  { key: "Français", val: "FR-FR" },
];
const termsOfUse = [
  { key: "DE-DE", val: "DE" },
  { key: "ES-MX", val: "ES" },
  { key: "EN", val: "EN" },
  { key: "IT-IT", val: "IT" },
  { key: "FR-FR", val: "FR" },
  { key: "JA-JP", val: "JA" },
  { key: "PT-BR", val: "PT-BR" },
  { key: "ZH-CN", val: "ZH_CN" },
];
const onboardingVideoUrls = [
  { productId: "18", url: "https://cdn.jwplayer.com/manifests/qbYvLCyP.m3u8" },
  { productId: "20", url: "https://cdn.jwplayer.com/manifests/CODmYBc3.m3u8" },
  { productId: "25", url: "" },
  { productId: "26", url: "" },
  { productId: "27", url: "" },
  { productId: "28", url: "" },
];
const twtLicenseMapper = [
  { productId: "22", language: "DE-DE" },
  { productId: "23", language: "FR-FR" },
  { productId: "24", language: "ES-MX" },
  { productId: "26", language: "DE-DE" },
  { productId: "27", language: "FR-FR" },
  { productId: "28", language: "ES-MX" },
  { productId: "18", language: "EN" },
  { productId: "20", language: "EN" },
  { productId: "21", language: "EN" },
  { productId: "25", language: "EN" },
];
const badgeRange = [
  { min: 50, max: 69, type: "Bronze" },
  { min: 70, max: 84, type: "Silver" },
  { min: 85, max: 100, type: "Gold" },
];
const scheduleCourseStatus = [
  { status: 1, statusString: "In Planning" },
  { status: 3, statusString: "Active" },
  { status: 4, statusString: "Cancelled" },
  { status: 5, statusString: "Finished" },
  { status: 7, statusString: "Pending" },
];
const activeStatus = ["Welcome", "Not Started", "In progress", "Completed"];
const soloProductIdMap = { "21": "57", "22": "58", "23": "59", "24": "60" };
const twtSessionsDays = "14";

/* EMAIL TEMPLATE, CULTURE NOTES and ACCENTS AND DIALECTS data*/

const AccentsAndDialectsDD = [
  {
    ContinentList: ["AF", "AS", "AU", "CA", "CE", "EU", "MI", "NO", "SO"],

    ContinentMap: [
      {
        Name: "AF",
        countries: ["CAMER", "EGYPT", "ETHIO", "GHANA", "GUINE", "NIGER", "SOUTH", "TANZA"],
        states: [],
      },
      {
        Name: "AS",
        countries: [
          "AFGHA",
          "CHINA",
          "INDIA",
          "INDON",
          "JAPAN",
          "KAZAK",
          "LEBAN",
          "MONGO",
          "NORTH",
          "PAKIS",
          "PHILI",
          "SINGA",
          "KOREA",
          "SRI_L",
          "TAIWA",
          "THAIL",
          "TURKM",
        ],
        states: [],
      },
      {
        Name: "AU",
        countries: ["AUSTR", "FIJI_", "NEW_Z"],
        states: [],
      },
      {
        Name: "CA",
        countries: ["BERMU", "CUBA_", "HAITI"],
        states: [],
      },
      {
        Name: "CE",
        countries: ["COSTA", "GUATE", "MARTI", "TRINI"],
        states: [],
      },
      {
        Name: "EU",
        countries: [
          "AUSTRI",
          "BELAR",
          "BELGI",
          "BULGA",
          "CYPRU",
          "CZECH",
          "DENMA",
          "ENGLA",
          "FINLA",
          "FRANC",
          "GEORG",
          "GERMA",
          "GREEC",
          "HUNGA",
          "IRELA",
          "ITALY",
          "MACED",
          "NETHE",
          "NORTH",
          "POLAN",
          "ROMAN",
          "RUSSI",
          "SCOTL",
          "SPAIN",
          "SWEDE",
          "SWITZ",
          "TURKE",
          "UKRAI",
          "WALES",
        ],
        states: [],
      },
      {
        Name: "MI",
        countries: ["IRAN_", "IRAQ_", "ISRAE", "KUWAI", "SAUDI", "SYRIA"],
        states: [],
      },
      {
        Name: "NO",
        countries: ["CANAD", "MEXIC", "US"],
        states: [
          "ALABA",
          "ALASK",
          "ARKAN",
          "CALIF",
          "FLORI",
          "GEORG_US",
          "HAWAI",
          "ILLIN",
          "INDIA_US",
          "KANSA",
          "KENTU",
          "LOUIS",
          "MAINE",
          "MARYL",
          "MASSA",
          "MICHI",
          "MINNE",
          "MISSI",
          "MISSO",
          "MONTA",
          "NEBRA",
          "NEW_H",
          "NEW_J",
          "NEW_Y",
          "NCARO",
          "NDAKO",
          "OHIO_",
          "OKLAH",
          "PENNS",
          "SOUTH_US",
          "TENNE",
          "TEXAS",
          "VIRGI",
          "WEST_",
          "WISCO",
        ],
      },
      {
        Name: "SO",
        countries: ["ARGEN", "BRAZI", "CHILE", "COLOM", "PARAG", "PERU_", "VENEZ"],
        states: [],
      },
    ],
  },
];

const cultureNotesDD = [
  {
    ContinentList: ["NoAm", "Cenam", "SoAm", "EUR", "ASIA", "CenASIA", "SoEASIA", "MidEAST", "AFR", "AUST"],
    ContinentMap: [
      {
        Name: "NoAm",
        Countries: ["Cana", "Mexi", "Uniteds"],
      },
      {
        Name: "Cenam",
        Countries: ["CostaR", "DomRep", "Guate", "Jama", "Panam", "TriniTob"],
      },
      {
        Name: "SoAm",
        Countries: ["Arge", "Braz", "Chil", "Vene", "Colomb", "Peru", "Urug"],
      },
      {
        Name: "EUR",
        Countries: [
          "Austria",
          "Belg",
          "Bulg",
          "Croatia",
          "Czec",
          "Denm",
          "Finl",
          "Fran",
          "Germ",
          "Greec",
          "Hung",
          "Icel",
          "Irel",
          "Ital",
          "Lith",
          "Luxem",
          "Neth",
          "Norw",
          "Pola",
          "Port",
          "Roma",
          "Russ",
          "Serb",
          "Slovakia",
          "Slovania",
          "Spai",
          "Swed",
          "Swit",
          "Turk",
          "Ukra",
          "Unitedk",
        ],
      },
      {
        Name: "ASIA",
        Countries: ["Chin", "Hong", "Indi", "Japa", "Mongo", "Pakis", "SoKore", "SriLan", "Taiw"],
      },
      {
        Name: "CenASIA",
        Countries: ["Afgh", "Azer", "Kaza"],
      },
      {
        Name: "SoEASIA",
        Countries: ["Camb", "Indo", "Malay", "Phil", "Sing", "Thai", "Viet"],
      },
      {
        Name: "MidEAST",
        Countries: ["Bah", "Iran", "Iraq", "Isra", "Jor", "Kuw", "Leb", "Oma", "Qat", "SauArb", "UAE"],
      },
      {
        Name: "AFR",
        Countries: [
          "Alger",
          "Angol",
          "Egyp",
          "Ghana",
          "Guin",
          "Keny",
          "Malaw",
          "Moroc",
          "Mozam",
          "Nige",
          "SoAfr",
          "Tanz",
          "Ugan",
          "Zamb",
        ],
      },
      {
        Name: "AUST",
        Countries: ["Austra", "NewZea"],
      },
    ],
  },
];

const cultureNotesTopicDD = [
  {
    CategoryList: ["BizA", "CL", "COM", "FIN", "HR", "GG", "GandI", "MKT", "MLS", "MwP", "MNY", "TPHO", "TIME", "TRV"],
    CategoryMap: [
      {
        Name: "BizA",
        Topics: ["BizAn1", "BizAn2"],
      },
      {
        Name: "CL",
        Topics: ["CLn1"],
      },
      {
        Name: "COM",
        Topics: ["COMn1", "COMn2", "COMn3", "COMn4", "COMn5", "COMn6"],
      },
      {
        Name: "FIN",
        Topics: ["FINn1", "FINn2"],
      },
      {
        Name: "HR",
        Topics: ["HRn1"],
      },
      {
        Name: "GG",
        Topics: ["GGn1", "GGn2", "GGn3", "GGn4"],
      },
      {
        Name: "GandI",
        Topics: ["GandIn1", "GandIn2", "GandIn3", "GandIn4"],
      },
      {
        Name: "MKT",
        Topics: ["MKTn1", "MKTn2"],
      },
      {
        Name: "MLS",
        Topics: ["MLSn1", "MLSn2", "MLSn3", "MLSn4", "MLSn5", "MLSn6"],
      },
      {
        Name: "MwP",
        Topics: ["MwPn1", "MwPn2", "MwPn3", "MwPn4", "MwPn5", "MwPn6"],
      },
      {
        Name: "MNY",
        Topics: ["MNYn1"],
      },
      {
        Name: "TPHO",
        Topics: ["TPHOn1", "TPHOn2"],
      },
      {
        Name: "TIME",
        Topics: ["TIMEn1", "TIMEn2", "TIMEn3", "TIMEn4", "TIMEn5"],
      },
      {
        Name: "TRV",
        Topics: ["TRVn1", "TRVn2"],
      },
    ],
  },
];

const EmailTemplateDD = [
  {
    translation: "wcGroup1",
    name: "Apologies",
    topics: [
      {
        id: "dbdded05-17f4-44a3-af3c-d52f2464abc3",
        name: "Apology for a Delay in a Project",
        translation: "wcTitle11",
      },
    ],
  },
  {
    translation: "wcGroup1",
    name: "Apologies",
    topics: [
      {
        id: "6e0ad38a-77b5-4a22-ba45-2fdace8ab353",
        name: "Apology for an Account Error",
        translation: "wcTitle12",
      },
    ],
  },
  {
    translation: "wcGroup1",
    name: "Apologies",
    topics: [
      {
        id: "a46274b7-e367-4931-b910-baa5ebb6a278",
        name: "Apology for a Late Shipment",
        translation: "wcTitle13",
      },
    ],
  },
  {
    translation: "wcGroup1",
    name: "Apologies",
    topics: [
      {
        id: "72962976-a6f3-4b1e-b46d-639a01afecf6",
        name: "Apology for Delivery of Damaged Goods",
        translation: "wcTitle14",
      },
    ],
  },
  {
    translation: "wcGroup1",
    name: "Apologies",
    topics: [
      {
        id: "b51e229b-a2c8-4262-be5e-38bbdb888651",
        name: "Apology for Missing a Meeting",
        translation: "wcTitle15",
      },
    ],
  },
  {
    translation: "wcGroup2",
    name: "Complaints",
    topics: [
      {
        id: "b8a9c18d-e842-4fa2-8732-d26521036318",
        name: "General Complaint",
        translation: "wcTitle21",
      },
    ],
  },
  {
    translation: "wcGroup2",
    name: "Complaints",
    topics: [
      {
        id: "311698b4-25b5-4695-a6c8-2c921f7f91c4",
        name: "Complaint about a Problem with a Product",
        translation: "wcTitle22",
      },
    ],
  },
  {
    translation: "wcGroup2",
    name: "Complaints",
    topics: [
      {
        id: "23fcd033-33ca-43d0-95f7-b050832fa648",
        name: "Complaint about an Overcharge to an Account",
        translation: "wcTitle23",
      },
    ],
  },
  {
    translation: "wcGroup3",
    name: "Compliments",
    topics: [
      {
        id: "6211f1c4-878c-428a-a104-580d04005198",
        name: "Compliment to a Colleague on a Project",
        translation: "wcTitle31",
      },
    ],
  },
  {
    translation: "wcGroup3",
    name: "Compliments",
    topics: [
      {
        id: "bcba45bc-8776-44d8-a22e-d35c86f40dfe",
        name: "Compliment about Customer Service",
        translation: "wcTitle32",
      },
    ],
  },
  {
    translation: "wcGroup3",
    name: "Compliments",
    topics: [
      {
        id: "7e610148-9611-426e-9760-9fbd081d436c",
        name: "Compliment about a Product",
        translation: "wcTitle33",
      },
    ],
  },
  {
    translation: "wcGroup4",
    name: "Congratulations",
    topics: [
      {
        id: "7bb0fdf9-0f17-48a3-b25e-dc948af5fc89",
        name: "Congratulations on a Promotion (Formal)",
        translation: "wcTitle41",
      },
    ],
  },
  {
    translation: "wcGroup4",
    name: "Congratulations",
    topics: [
      {
        id: "f6c25559-51d7-4269-a061-da969690a60b",
        name: "Congratulations on a Promotion (Informal)",
        translation: "wcTitle42",
      },
    ],
  },
  {
    translation: "wcGroup4",
    name: "Congratulations",
    topics: [
      {
        id: "7d2882ef-d12c-4cc2-b94a-a3a1e27c414a",
        name: "Congratulations on a Personal Event",
        translation: "wcTitle43",
      },
    ],
  },
  {
    translation: "wcGroup5",
    name: "Documents",
    topics: [
      {
        id: "59f9d44e-f50d-4bbd-822f-0de7ffc7274a",
        name: "Requested Document",
        translation: "wcTitle51",
      },
    ],
  },
  {
    translation: "wcGroup5",
    name: "Documents",
    topics: [
      {
        id: "5d5d2079-4a15-4dc6-986f-fa54c03118df",
        name: "Order Form or Purchase Order",
        translation: "wcTitle52",
      },
    ],
  },
  {
    translation: "wcGroup5",
    name: "Documents",
    topics: [
      {
        id: "6ef65e56-83aa-4872-93c4-fde2a56901c7",
        name: "Invoice",
        translation: "wcTitle53",
      },
    ],
  },
  {
    translation: "wcGroup6",
    name: "Invitations",
    topics: [
      {
        id: "87ddb349-666c-4956-9508-dd79888646f2",
        name: "Invitation to a Social Event",
        translation: "wcTitle61",
      },
    ],
  },
  {
    translation: "wcGroup6",
    name: "Invitations",
    topics: [
      {
        id: "337c02fd-bc83-40b0-83c3-11f7e2c631f2",
        name: "Invitation to a Business Event",
        translation: "wcTitle62",
      },
    ],
  },
  {
    translation: "wcGroup6",
    name: "Invitations",
    topics: [
      {
        id: "bb0b8893-c762-42e4-928b-23aa3c88206d",
        name: "Accepting an Invitation",
        translation: "wcTitle63",
      },
    ],
  },
  {
    translation: "wcGroup6",
    name: "Invitations",
    topics: [
      {
        id: "da3db253-789d-4ff1-8293-ddffe7f5b0bb",
        name: "Declining an Invitation",
        translation: "wcTitle64",
      },
    ],
  },
  {
    translation: "wcGroup6",
    name: "Invitations",
    topics: [
      {
        id: "29682d3a-fb3f-4c80-9d68-61abf1c725a8",
        name: "Canceling a Business Event",
        translation: "wcTitle65",
      },
    ],
  },
  {
    translation: "wcGroup7",
    name: "Job Applications",
    topics: [
      {
        id: "ea79c9ff-ef50-46b6-9540-599a2d27819d",
        name: "Acknowledgement of Receipt of Application",
        translation: "wcTitle71",
      },
    ],
  },
  {
    translation: "wcGroup8",
    name: "Marketing and Sales",
    topics: [
      {
        id: "d4ef9de6-09cf-4cf2-b350-9148939dc552",
        name: "Announcement of a New Product",
        translation: "wcTitle81",
      },
    ],
  },
  {
    translation: "wcGroup8",
    name: "Marketing and Sales",
    topics: [
      {
        id: "05d6d1de-b823-4cb8-a1b7-978260d45f7d",
        name: "Announcement of a New Area Representative",
        translation: "wcTitle82",
      },
    ],
  },
  {
    translation: "wcGroup8",
    name: "Marketing and Sales",
    topics: [
      {
        id: "0f7fa0ba-7eec-4c30-938b-23ed0dacbd0b",
        name: "New Product Demo",
        translation: "wcTitle83",
      },
    ],
  },
  {
    translation: "wcGroup8",
    name: "Marketing and Sales",
    topics: [
      {
        id: "ff4c1946-a682-4520-b595-02326eab54f5",
        name: "Change of Billing Address",
        translation: "wcTitle84",
      },
    ],
  },
  {
    translation: "wcGroup8",
    name: "Marketing and Sales",
    topics: [
      {
        id: "a121d47a-df0e-4af9-a8ee-dc7ef38a761c",
        name: "Follow-Up after a First Sales Meeting",
        translation: "wcTitle85",
      },
    ],
  },
  {
    translation: "wcGroup8",
    name: "Marketing and Sales",
    topics: [
      {
        id: "bd01834b-c8cc-450d-8b1a-2303c02ab0a1",
        name: "New Customer Welcome",
        translation: "wcTitle86",
      },
    ],
  },
  {
    translation: "wcGroup8",
    name: "Marketing and Sales",
    topics: [
      {
        id: "01c8fbf9-96c8-482b-9355-5e6d7812de19",
        name: "Holiday Message to Stockholders or Customers",
        translation: "wcTitle87",
      },
    ],
  },
  {
    translation: "wcGroup9",
    name: "Meetings",
    topics: [
      {
        id: "f9620f57-4979-49a3-a51a-1f690fc9ceb5",
        name: "Proposing a Time for a Meeting",
        translation: "wcTitle91",
      },
    ],
  },
  {
    translation: "wcGroup9",
    name: "Meetings",
    topics: [
      {
        id: "3d291668-7a3e-4705-a4d9-427c2f3986b2",
        name: "Confirming a Meeting",
        translation: "wcTitle92",
      },
    ],
  },
  {
    translation: "wcGroup9",
    name: "Meetings",
    topics: [
      {
        id: "6a575fd2-87ec-4cee-b418-265f3d2b3e33",
        name: "Postponing a Meeting",
        translation: "wcTitle93",
      },
    ],
  },
  {
    translation: "wcGroup9",
    name: "Meetings",
    topics: [
      {
        id: "db5f94ab-42cd-48af-885e-1ee87a8ddff8",
        name: "Canceling a Meeting",
        translation: "wcTitle94",
      },
    ],
  },
  {
    translation: "wcGroup9",
    name: "Meetings",
    topics: [
      {
        id: "29788946-2657-4572-825e-269e6095c9bd",
        name: "Summarizing a Meeting",
        translation: "wcTitle95",
      },
    ],
  },
  {
    translation: "wcGroup10",
    name: "Notices",
    topics: [
      {
        id: "551c7826-bd9e-4e6d-ad9c-3e2767fce3b2",
        name: "Suspended Account",
        translation: "wcTitle101",
      },
    ],
  },
  {
    translation: "wcGroup10",
    name: "Notices",
    topics: [
      {
        id: "6350981f-24b1-44c3-91e0-57a3734f0f24",
        name: "Request to Close an Account",
        translation: "wcTitle102",
      },
    ],
  },
  {
    translation: "wcGroup11",
    name: "Orders",
    topics: [
      {
        id: "f99192f9-6014-439c-956f-01ed5bf4a40b",
        name: "Confirming an Order",
        translation: "wcTitle111",
      },
    ],
  },
  {
    translation: "wcGroup11",
    name: "Orders",
    topics: [
      {
        id: "571b9d45-2feb-458b-8e3e-9fe1726b6238",
        name: "Providing Shipping Confirmation",
        translation: "wcTitle112",
      },
    ],
  },
  {
    translation: "wcGroup11",
    name: "Orders",
    topics: [
      {
        id: "854f48a8-38d4-43f2-b3a2-83e6eaad9c33",
        name: "Canceling an Order",
        translation: "wcTitle113",
      },
    ],
  },
  {
    translation: "wcGroup11",
    name: "Orders",
    topics: [
      {
        id: "159c4370-cb80-4447-b6d8-f95f27855bb9",
        name: "Changing an Order",
        translation: "wcTitle114",
      },
    ],
  },
  {
    translation: "wcGroup11",
    name: "Orders",
    topics: [
      {
        id: "48353517-1d63-488c-88a1-6c64496a70e3",
        name: "Acknowledging a Delivery",
        translation: "wcTitle115",
      },
    ],
  },
  {
    translation: "wcGroup12",
    name: "Pricing Information",
    topics: [
      {
        id: "043a1c9b-55bd-4a41-ab92-c71ccc1fb3da",
        name: "Providing Pricing Information",
        translation: "wcTitle121",
      },
    ],
  },
  {
    translation: "wcGroup12",
    name: "Pricing Information",
    topics: [
      {
        id: "948925dd-9020-45ef-a8b1-c9f57b3510cd",
        name: "Accepting a Price Quotation",
        translation: "wcTitle122",
      },
    ],
  },
  {
    translation: "wcGroup12",
    name: "Pricing Information",
    topics: [
      {
        id: "a7b6aa9d-f594-410f-a9ec-a20f9514aa3a",
        name: "Rejecting a Price Quotation",
        translation: "wcTitle123",
      },
    ],
  },
  {
    translation: "wcGroup13",
    name: "Requests",
    topics: [
      {
        id: "2d7df5e8-2b01-4727-ac80-c647b8e12611",
        name: "Request for Clarification of Information",
        translation: "wcTitle131",
      },
    ],
  },
  {
    translation: "wcGroup13",
    name: "Requests",
    topics: [
      {
        id: "73adc02d-7c6b-4905-9c82-dca35a62fec1",
        name: "Request for Information about a Product",
        translation: "wcTitle132",
      },
    ],
  },
  {
    translation: "wcGroup13",
    name: "Requests",
    topics: [
      {
        id: "60d33268-8277-47f7-95f8-47b6e9eec7b2",
        name: "Request for Information about a Service",
        translation: "wcTitle133",
      },
    ],
  },
  {
    translation: "wcGroup14",
    name: "Thank You",
    topics: [
      {
        id: "ca6e52a6-3c8c-477a-8de8-8ed9a4e4f386",
        name: "General Thanks",
        translation: "wcTitle141",
      },
    ],
  },
];

const TemplateMapper = [
  {
    Id: "226083",
    uuId: "dbdded05-17f4-44a3-af3c-d52f2464abc3",
  },
  {
    Id: "226084",
    uuId: "6e0ad38a-77b5-4a22-ba45-2fdace8ab353",
  },
  {
    Id: "226085",
    uuId: "a46274b7-e367-4931-b910-baa5ebb6a278",
  },
  {
    Id: "226087",
    uuId: "72962976-a6f3-4b1e-b46d-639a01afecf6",
  },
  {
    Id: "226103",
    uuId: "b51e229b-a2c8-4262-be5e-38bbdb888651",
  },
  {
    Id: "226121",
    uuId: "b8a9c18d-e842-4fa2-8732-d26521036318",
  },
  {
    Id: "226122",
    uuId: "311698b4-25b5-4695-a6c8-2c921f7f91c4",
  },
  {
    Id: "226123",
    uuId: "23fcd033-33ca-43d0-95f7-b050832fa648",
  },
  {
    Id: "226118",
    uuId: "6211f1c4-878c-428a-a104-580d04005198",
  },
  {
    Id: "226119",
    uuId: "bcba45bc-8776-44d8-a22e-d35c86f40dfe",
  },
  {
    Id: "226120",
    uuId: "7e610148-9611-426e-9760-9fbd081d436c",
  },
  {
    Id: "226112",
    uuId: "7bb0fdf9-0f17-48a3-b25e-dc948af5fc89",
  },
  {
    Id: "226113",
    uuId: "f6c25559-51d7-4269-a061-da969690a60b",
  },
  {
    Id: "226114",
    uuId: "7d2882ef-d12c-4cc2-b94a-a3a1e27c414a",
  },
  {
    Id: "226115",
    uuId: "59f9d44e-f50d-4bbd-822f-0de7ffc7274a",
  },
  {
    Id: "226116",
    uuId: "5d5d2079-4a15-4dc6-986f-fa54c03118df",
  },
  {
    Id: "226117",
    uuId: "6ef65e56-83aa-4872-93c4-fde2a56901c7",
  },
  {
    Id: "226070",
    uuId: "87ddb349-666c-4956-9508-dd79888646f2",
  },
  {
    Id: "226071",
    uuId: "337c02fd-bc83-40b0-83c3-11f7e2c631f2",
  },
  {
    Id: "226072",
    uuId: "bb0b8893-c762-42e4-928b-23aa3c88206d",
  },
  {
    Id: "226073",
    uuId: "da3db253-789d-4ff1-8293-ddffe7f5b0bb",
  },
  {
    Id: "226074",
    uuId: "29682d3a-fb3f-4c80-9d68-61abf1c725a8",
  },
  {
    Id: "226133",
    uuId: "ea79c9ff-ef50-46b6-9540-599a2d27819d",
  },
  {
    Id: "226124",
    uuId: "d4ef9de6-09cf-4cf2-b350-9148939dc552",
  },
  {
    Id: "226125",
    uuId: "05d6d1de-b823-4cb8-a1b7-978260d45f7d",
  },
  {
    Id: "226126",
    uuId: "0f7fa0ba-7eec-4c30-938b-23ed0dacbd0b",
  },
  {
    Id: "226127",
    uuId: "ff4c1946-a682-4520-b595-02326eab54f5",
  },
  {
    Id: "226128",
    uuId: "a121d47a-df0e-4af9-a8ee-dc7ef38a761c",
  },
  {
    Id: "226129",
    uuId: "bd01834b-c8cc-450d-8b1a-2303c02ab0a1",
  },
  {
    Id: "226130",
    uuId: "01c8fbf9-96c8-482b-9355-5e6d7812de19",
  },
  {
    Id: "226078",
    uuId: "f9620f57-4979-49a3-a51a-1f690fc9ceb5",
  },
  {
    Id: "226079",
    uuId: "3d291668-7a3e-4705-a4d9-427c2f3986b2",
  },
  {
    Id: "226080",
    uuId: "6a575fd2-87ec-4cee-b418-265f3d2b3e33",
  },
  {
    Id: "226081",
    uuId: "db5f94ab-42cd-48af-885e-1ee87a8ddff8",
  },
  {
    Id: "226082",
    uuId: "29788946-2657-4572-825e-269e6095c9bd",
  },
  {
    Id: "226131",
    uuId: "551c7826-bd9e-4e6d-ad9c-3e2767fce3b2",
  },
  {
    Id: "226132",
    uuId: "6350981f-24b1-44c3-91e0-57a3734f0f24",
  },
  {
    Id: "226107",
    uuId: "f99192f9-6014-439c-956f-01ed5bf4a40b",
  },
  {
    Id: "226108",
    uuId: "571b9d45-2feb-458b-8e3e-9fe1726b6238",
  },
  {
    Id: "226109",
    uuId: "854f48a8-38d4-43f2-b3a2-83e6eaad9c33",
  },
  {
    Id: "226110",
    uuId: "159c4370-cb80-4447-b6d8-f95f27855bb9",
  },
  {
    Id: "226111",
    uuId: "48353517-1d63-488c-88a1-6c64496a70e3",
  },
  {
    Id: "226075",
    uuId: "043a1c9b-55bd-4a41-ab92-c71ccc1fb3da",
  },
  {
    Id: "226076",
    uuId: "948925dd-9020-45ef-a8b1-c9f57b3510cd",
  },
  {
    Id: "226077",
    uuId: "a7b6aa9d-f594-410f-a9ec-a20f9514aa3a",
  },
  {
    Id: "226104",
    uuId: "2d7df5e8-2b01-4727-ac80-c647b8e12611",
  },
  {
    Id: "226105",
    uuId: "73adc02d-7c6b-4905-9c82-dca35a62fec1",
  },
  {
    Id: "226106",
    uuId: "60d33268-8277-47f7-95f8-47b6e9eec7b2",
  },
  {
    Id: "226134",
    uuId: "ca6e52a6-3c8c-477a-8de8-8ed9a4e4f386",
  },
];

const Templates = [
  {
    Id: "226070",
    class: "254",

    title: "Invitation to a Social Event",

    subject: "[event name or description]",

    message:
      "Dear [name]:\r\n<p>\r\nYou are invited to [event name] to celebrate [reason for event]. Here are the details.\r\n<p>\r\nWhen: [date and time of event]<p>\r\nWhere: [location of event]<p>\r\nAttire: [preferred attire: casual, informal, formal]<p>\r\nRSVP: [name] at [telephone number or email address] by [response date]\r\n<p>\r\nHope to see you there!\r\n<p>\r\n[name]",

    ref1: "2,10,4,4,120404",
    ref2: "4,8,6,4,40167",
  },
  {
    Id: "226071",
    class: "254",

    title: "Invitation to a Business Event",

    subject: "[event name or description]",

    message:
      "Dear [name]: <p>\r\n\r\nAs [title of executive] of [company name], I am delighted to invite you to [event name or description], to be held on [date] at [location].<p>\r\n\r\nThis event is designed to [description of event purpose]. Here are some highlights of this important event:\r\n<p>\r\n\r\n- [activity #1]\r\n- [activity #2]\r\n- [activity #3]\r\n- [activity #4]\r\n\r\n<p>\r\nFor more details, please go to [Web page URL] or call [name] at [phone number]. <p>\r\n\r\nI look forward to seeing you on [date of event]!\r\n<p>\r\nKind regards,\r\n<p>\r\n[name]\r\n[company name]\r\n[telephone number]",

    ref1: "2,10,4,4,120404",
    ref2: "4,8,6,4,40167",
  },
  {
    Id: "226072",
    class: "254",

    title: "Accepting an Invitation",

    subject: "[event name or description]",

    message:
      "Dear [name]:\r\n<p>\r\nThank you very much for inviting me to [name of event]. I am delighted to accept. I'll see you [date of event]. \r\n<p>\r\nBest wishes,\r\n<p>\r\n[name]\r\n[title]\r\n[company name]\r\n[telephone number]",

    ref1: "2,10,4,4,120404",
    ref2: "4,8,6,4,40167",
  },
  {
    Id: "226073",
    class: "254",

    title: "Declining an Invitation",

    subject: "[event name or description]",

    message:
      "Dear [name]:\r\n<p>\r\nThank you very much for inviting me to [name of event]. Unfortunately, I won't be able to attend as I have a previous engagement.\r\n<p>\r\nSincerely,\r\n<p>\r\n[name]\r\n[title]\r\n[company name]\r\n[telephone number]",

    ref1: "2,10,4,4,120404",
    ref2: "4,8,6,4,40167",
  },
  {
    Id: "226074",
    class: "254",

    title: "Canceling a Business Event",

    subject: "[event name or description]",

    message:
      "Dear [name]:\r\n<p>\r\nWe are very sorry to inform you that we have cancelled [event name or description] due to [reason]. \r\n<p>\r\nPlease accept our sincere apologies for any inconvenience this may cause you.\r\n<p>\r\nSincerely,\r\n<p>\r\n[name]\r\n[title]\r\n[company name]\r\n[telephone number]",
  },
  {
    Id: "226075",
    class: "254",

    title: "Providing Pricing Information",

    subject: "Your Price Inquiry about [product or service name]",

    message:
      "Dear [name]:\r\n<p>\r\nThank you for your interest in [product or service name]. Following is the pricing information that you requested:\r\n<p>\r\n[product or service name] [price]\r\n<p>\r\nThe attached document provides additional information about our company. If you have any further questions, please do not hesitate to contact me.\r\n<p>\r\nThank you again for your interest.\r\n<p>\r\nSincerely,\r\n<p>\r\n[name]\r\n[title]\r\n[company name]\r\n[telephone number]",
  },
  {
    Id: "226076",
    class: "254",

    title: "Accepting a Price Quotation",

    subject: "Your Price Quotation for [product or service name]",

    message:
      "Dear [name]:\r\n<p>\r\nThank you for sending the information about [product or service name]. I have discussed the price quotation with my colleagues and we agree that the cost is reasonable. Please call me at [telephone number] or send me an email so that we can set up a meeting to discuss next steps.\r\n<p>\r\nSincerely,\r\n<p>\r\n[name]\r\n[title]\r\n[company name]\r\n[telephone number]",
  },
  {
    Id: "226077",
    class: "254",

    title: "Rejecting a Price Quotation",

    subject: "Your Price Quotation for [product or service name]",

    message:
      "Dear [name]:\r\n<p>\r\nThank you for sending the pricing information about [product or service name]. I have discussed your price quotation with my colleagues. Unfortunately, it is higher than we had expected. If there is a possibility of negotiating a price reduction, please call me at [telephone number] or send me an email. Otherwise, we will not be able to make a purchase at this time.\r\n<p>\r\nSincerely,\r\n<p>\r\n[name]\r\n[title]\r\n[company name]\r\n[telephone number]",
  },
  {
    Id: "226078",
    class: "254",

    title: "Proposing a Time for a Meeting",

    subject: "[description of meeting] Meeting",

    message:
      "Hello, everyone. \r\n<p>\r\nWe would like to have a meeting to discuss [subject of meeting] on [date] at [time]. \r\n<p>\r\nThe proposed agenda is below. If you have additional items that you would like to discuss, please send me an email.\r\n\r\n- [agenda item]\r\n- [agenda item]\r\n- [agenda item]\r\n- [agenda item]\r\n\r\n<p>\r\nPlease respond to this email by [date or time] to confirm whether or not this time works for you. If you are unable to attend the meeting at the proposed time, please let me know what alternate times would work for you.\r\n<p>\r\nThanks!\r\n<p>\r\n[name]",
  },
  {
    Id: "226079",
    class: "254",

    title: "Confirming a Meeting",

    subject: "[description of meeting] Meeting: Confirmation",

    message:
      "Hello, everyone. \r\n<p>\r\nThank you all for confirming that you can attend the meeting on [date] at [time] to discuss [topic of meeting]. We will be meeting in [room name]. \r\n<p>	\r\nAttached is the updated agenda. If you have any additional items, please send me an email.\r\n<p>\r\n\r\n- [agenda item]\r\n- [agenda item]\r\n- [agenda item]\r\n- [agenda item]\r\n\r\n<p>\r\nI look forward to seeing you.\r\n<p>\r\n[name]",
  },
  {
    Id: "226080",
    class: "254",

    title: "Postponing a Meeting",

    subject: "[description of meeting] Meeting: Postponed",

    message:
      "Hello, everyone. \r\n<p>\r\nThank you for responding to my email about the [description of meeting] meeting. The proposed day and time was not good for some of you, and so I would like to reschedule the meeting. I've listed some alternative dates and times below. Please let me know if any of these times would not be convenient for you.\r\n<p>\r\n\r\n- [first date and time]\r\n- [second date and time]\r\n- [third date and time]\r\n\r\n<p>\r\nOnce I hear back from everyone, I will confirm the new date and time.\r\n<p>\r\nThank you.\r\n<p>\r\n[name]",
  },
  {
    Id: "226081",
    class: "254",

    title: "Canceling a Meeting",

    subject: "[description of meeting] Meeting: Canceled",

    message:
      "Hello, everyone. \r\n<p>\r\nI'm writing to tell you that the [describe meeting] meeting has been canceled because [reason for canceling the meeting]. I will let you know if we are able to reschedule it later.\r\n<p>\r\nThank you.\r\n<p>\r\n[name]",
  },
  {
    Id: "226082",
    class: "254",

    title: "Summarizing a Meeting",

    subject: "[description of meeting] Meeting: Summary",

    message:
      "Here is a summary of the [description of meeting] meeting on [date]. The main points are below.\r\n<p>\r\n\r\n- [point #1]\r\n- [point #2]\r\n- [point #3]\r\n- [point #4]\r\n\r\n<p>\r\nIf you have additional items you would like to include, please send me an email and I will distribute an updated summary.\r\n<p>\r\nThank you.\r\n<p>\r\n[name]",

    ref1: "6,1,9,4,60329",
  },
  {
    Id: "226083",
    class: "254",

    title: "Apology for a Delay in a Project",

    subject: "[name of project] Delay",

    message:
      "Dear [name]:\r\n<p>\r\nI'm writing to apologize for the delay in [description of project]. We had a problem with [description of problem]. We are currently working on the problem and expect to have it resolved by [date].\r\n<p>\r\nIf you need further information, do not hesitate to contact me at [telephone number].\r\n<p>\r\nOnce again, I apologize for the delay.\r\n<p>\r\nSincerely,\r\n<p>\r\n[name]\r\n[title]\r\n[company name]\r\n[telephone number]",

    ref1: "3,6,5,4,40625",
  },
  {
    Id: "226084",
    class: "254",

    title: "Apology for an Account Error",

    subject: "Your Account with [your company name]",

    message:
      "Dear [customer name]:\r\n<p>\r\nI am sorry to inform you that we have made an error in your account. Please read the description of the problem below.\r\n<p>\r\n[description of the error]\r\n<p>\r\nWe will correct your account records and send you an adjusted statement. Please accept our apology for the mistake.\r\n<p>\r\nSincerely,\r\n<p>\r\n[name]\r\n[title]\r\n[company name]\r\n[telephone number]",

    ref1: "3,6,5,4,40625",
  },
  {
    Id: "226085",
    class: "254",

    title: "Apology for a Late Shipment",

    subject: "Your Order with [your company name]",

    message:
      "Dear [customer name]:\r\n<p>\r\nWe are very sorry to inform you that shipment of your order [order number] has been delayed because [reason for delay]. Our new estimated shipping date is [new shipping date]. If you have any questions about this delay, please contact our Customer Service Department at [email address or phone number]. We will send you an email confirmation when the order has left our warehouse.\r\n<p>\r\nOnce again, we are very sorry for this delay and we apologize for any inconvenience it may cause.\r\n<p>\r\nSincerely,\r\n<p>\r\n[name]\r\n[title]\r\n[company name]\r\n[telephone number]",

    ref1: "3,6,5,4,40625",
  },
  {
    Id: "226086",
    class: "254",

    title: "Apology for a Late Shipment",

    subject: "Your Order with [your company name]",

    message:
      "Dear [customer name]:\r\n<p>\r\nWe are very sorry to inform you that shipment of your order [order number] has been delayed because [reason for delay]. Our new estimated shipping date is [new shipping date]. If you have any questions about this delay, please contact our Customer Service Department at [email address or phone number]. We will send you an email confirmation when the order has left our warehouse.\r\n<p>\r\nOnce again, we are very sorry for this delay and we apologize for any inconvenience it may cause.\r\n<p>\r\nSincerely,\r\n<p>\r\n[name]\r\n[title]\r\n[company name]\r\n[telephone number]",

    ref1: "3,6,5,4,40625",
  },
  {
    Id: "226087",
    class: "254",

    title: "Apology for Delivery of Damaged Goods",

    subject: "Your Order with [your company name]",

    message:
      "Dear [customer name]:\r\n<p>\r\nWe were very sorry to learn that your order [order number] was damaged during shipping. Per your request, we are sending a new shipment. It should arrive by [approximate date]. \r\n<p>\r\nIf you have any questions, please contact me at [phone number] or reply to this email.\r\n<p>\r\nPlease accept our sincerest apologies for any inconvenience this has caused.\r\n<p>\r\nSincerely,\r\n<p>\r\n[name]\r\n[title]\r\n[company name]\r\n[telephone number]\r\n<p>",

    ref1: "3,6,5,4,40625",
  },
  {
    Id: "226103",
    class: "254",

    title: "Apology for Missing a Meeting",

    subject: "[name of meeting] Meeting",

    message:
      "Dear [name]:\r\n<p>\r\nI'm very sorry that I missed the [name of meeting] meeting. [sentence with reason for missing the meeting]. I would be happy to meet with you or someone else who was at the meeting to get a summary of the discussion. Please let me know what you think would work best. \r\n<p>\r\nOnce again, please accept my apologies.  \r\n<p>\r\nSincerely,\r\n<p>\r\n[name]",
    ref1: "3,6,5,4,40625",
  },
  {
    Id: "226104",
    class: "254",

    title: "Request for Clarification of Information",

    subject: "[point that needs clarification]",

    message:
      "Dear [name]:\r\n<p>	\r\nThank you for the information about [topic]. It was extremely helpful. However, there was one point that I didnot understand. I would appreciate it if you could explain [point that needs clarification]. \r\n<p>\r\nThank you. I look forward to hearing from you.\r\n<p>\r\nRegards,\r\n<p>\r\n[name]\r\n[title]\r\n[company name]\r\n[telephone number]",

    ref1: "2,2,6,4,120246",
    ref2: "5,9,4,4,60184",
  },
  {
    Id: "226105",
    class: "254",

    title: "Request for Information about a Product",

    subject: "[name of product]",

    message:
      "To Whom It May Concern:\r\n<p>\r\nI'm [job title] at [company name]. [sentence describing what company does].\r\n<p>\r\nI'm very interested in one of your products, [name of product]. I would appreciate it if you could send me some information or give me your Web site address.\r\n<p>\r\nThank you!\r\n<p>\r\nSincerely,\r\n<p>\r\n[name]\r\n[title]\r\n[company name]\r\n[telephone number]",

    ref1: "2,2,6,4,120246",
    ref2: "5,9,4,4,60184",
  },
  {
    Id: "226106",
    class: "254",

    title: "Request for Information about a Service",

    subject: "[name of service]",

    message:
      "To Whom It May Concern:\r\n<p>\r\nI'm [job title] at [company name]. We [description of what your company does].\r\n<p>\r\nI'm very interested in the services that your company provides. I would appreciate it if you could send me some information or give me your Web site address so that I can find out more about your company. I'm particularly interested in [name of service].\r\n<p>\r\nThank you!\r\n<p>\r\nSincerely,\r\n<p>\r\n[name]\r\n[title]\r\n[company name]\r\n[telephone number]",

    ref1: "2,2,6,4,120246",
    ref2: "5,9,4,4,60184",
  },
  {
    Id: "226107",
    class: "254",

    title: "Confirming an Order",

    subject: "Your Order with [company's name]",

    message:
      "Thank you for your order, [customer name]!\r\n<p>\r\nThis is to confirm that we have received your order. Your order number is [order number]. Please check the information below to confirm that it is correct. If there is a problem, please contact our Customer Service Department at [email address or telephone number]. We will send you an email confirmation when your order has shipped.\r\n<p>\r\n<p><b>Shipping address:</b></p> \r\n<p>[customer's shipping address]</p>\r\n<p><b>Billing Address:</b></p>\r\n<p>[customer's billing address]</p>\r\n<p>\r\n<b>Item Name</b>\\t\\t\\t<b>Item Quantity</b>\\t\\t<b>Item Price</b><p>\r\n[name of item #1]\\t\\t[quantity]\\t\\t[price]<p>\r\n[name of item #2]\\t\\t[quantity]\\t\\t[price]<p>\r\n<p>\r\n<b>Subtotal of All Items:</b> [total charge from items in table]<p>\r\n<b>Shipping and Handling:</b> [shipping and handling charges]<p>\r\n<b>Total for This Order:</b> [order total]						\r\n<p>\r\n<b>Shipping Method:</b> [shipping method]\r\n<p>\r\nThank you again for your order!\r\n<p>\r\nSincerely,<p>		\r\n[name]\r\n[title]\r\n[company name]\r\n[telephone number]",

    ref1: "9,5,5,4,100105",
  },
  {
    Id: "226108",
    class: "254",

    title: "Providing Shipping Confirmation",

    subject: "Your Order [order number]",

    message:
      "Thank you for your order, [customer name]! \r\n<p>\r\nThis is to confirm that we shipped your order [order number] on [shipping date]. It should arrive between [earliest arrival date] and [latest delivery date]. If you have any questions, please send us an email at [customer service email address] or call us at [customer service telephone number]. Please include your order number in all communication with us.\r\n<p>\r\nThank you again for your order!\r\n<p>\r\nSincerely,\r\n<p>		\r\n[name]\r\n[title]\r\n[company name]\r\n[telephone number]",
  },
  {
    Id: "226109",
    class: "254",

    title: "Canceling an Order",

    subject: "Our Order [order number]",

    message:
      "To Whom It May Concern:\r\n<p>\r\nI need to cancel our order with [company name]. The order number is [order number]. If you have any questions, please contact me at [your telephone number] or reply to this email. I apologize for any inconvenience this may cause.\r\n<p>\r\nSincerely,\r\n<p>\r\n[name]\r\n[title]\r\n[company name]\r\n[telephone number]",
  },
  {
    Id: "226110",
    class: "254",

    title: "Changing an Order",

    subject: "Our Order [order number]",

    message:
      "To Whom It May Concern:\r\n<p>\r\nI would like to change an order that my company made on [date]. The order number is [order number]. I would like to [description of the change]. If there is a problem with this request, please call me at [telephone number] send me an email. Thank you for your prompt attention.\r\n<p>\r\nSincerely,\r\n<p>\r\n[name]\r\n[title]\r\n[company name]\r\n[telephone number]",
  },
  {
    Id: "226111",
    class: "254",

    title: "Acknowledging a Delivery",

    subject: "Our Order [order number]",

    message:
      "To Whom It May Concern:\r\n<p>\r\nThis is to confirm that order number [order number] arrived on [date]. \r\n<p>\r\nSincerely,\r\n<p>\r\n[name]\r\n[title]\r\n[company name]\r\n[telephone number]",
  },
  {
    Id: "226112",
    class: "254",

    title: "Congratulations on a Promotion (Formal)",

    subject: "Your Promotion to [new job title]",

    message:
      "Dear [name]:\r\n<p>\r\nCongratulations on your recent promotion to [job title]! [company name] made a wise decision. You have worked extremely hard and really deserve the promotion. \r\n<p>\r\nPlease accept my best wishes for success in your new position.\r\n<p>\r\nKind regards,\r\n<p>\r\n[name]",

    ref1: "6,12,4,1,60544",
  },
  {
    Id: "226113",
    class: "254",

    title: "Congratulations on a Promotion (Informal)",

    subject: "Your Promotion to [new job title]",

    message:
      "[name],\r\n<p>\r\nI was really happy to hear about your promotion to [new job title]! You've done a great job and really deserve this recognition. \r\n<p>\r\nCongratulations!\r\n<p>\r\n[name]",

    ref1: "6,12,4,1,60544",
  },
  {
    Id: "226114",
    class: "254",

    title: "Congratulations on a Personal Event",

    subject: "Congratulations!",

    message:
      "[name],\r\n<p>\r\nI just heard the good news about [event]. Congratulations! I wish you the very best!\r\n<p>\r\n[name]",

    ref1: "6,12,4,1,60544",
  },
  {
    Id: "226115",
    class: "254",

    title: "Requested Document",

    subject: "The Document You Requested",

    message:
      "Dear [name]:\r\n<p>\r\nYou asked me to send you a copy of [name of document]. I've attached it to this email. Please send a confirmation email when you receive it.\r\n<p>\r\nIf you need any further information or have any questions, I'd be happy to talk with you.\r\n<p>\r\nSincerely,\r\n<p>\r\n[name]\r\n[title]\r\n[company name]\r\n[telephone number]",
  },
  {
    Id: "226116",
    class: "254",

    title: "Order Form or Purchase Order",

    subject: "Our Order for [product or service being ordered]",

    message:
      "To Whom It May Concern:\r\n<p>\r\nWe are interested in purchasing [product] from your company. I've attached our order to this email. Please send a confirmation email when you receive it. \r\n<p>\r\nIf you need any further information or have any questions, please contact me.\r\n<p>\r\nSincerely,\r\n<p>\r\n[name]\r\n[title]\r\n[company name]\r\n[telephone number]",
  },
  {
    Id: "226117",
    class: "254",

    title: "Invoice",

    subject: "Your Order [order number]",

    message:
      "Dear [name]:\r\n<p>\r\nThank you for your order. We have shipped it and you should receive it by [date]. The invoice for your order is attached to this email. Please send a confirmation email when you receive it.\r\n<p>\r\nIf you need any further information or have any questions, please contact me.\r\n<p>\r\nSincerely,\r\n<p>\r\n[name]\r\n[title]\r\n[company name]\r\n[telephone number]",
  },
  {
    Id: "226118",
    class: "254",

    title: "Compliment to a Colleague on a Project",

    subject: "[name of project]",

    message:
      "[name],\r\n<p>\r\nI just wanted to tell you that I think that you dida great job on [project]. You worked hard and your ideas really helped us move the project along. I enjoyed working with you and I hope that we'll be able to work together again soon.\r\n<p>\r\nThanks!\r\n<p>\r\n[name]",
  },
  {
    Id: "226119",
    class: "254",

    title: "Compliment about Customer Service",

    subject: "[description of service]",

    message:
      "Dear [person or company]:\r\n<p>\r\nI'm writing to tell you how pleased we were with the service provided by your company. [sentence with example or detail of excellent service provided by the company] We were very impressed with your professionalism and will certainly keep you in mind for future needs.\r\n<p>\r\nSincerely,\r\n<p>\r\n[name]\r\n[title]\r\n[company name]\r\n[telephone number]",
  },
  {
    Id: "226120",
    class: "254",

    title: "Compliment about a Product",

    subject: "[name of product]",

    message:
      "Dear [name or person or company]:\r\n<p>\r\nI am writing to tell you how much we like the [product] that we purchased from [name of company]. We are especially impressed with [example of high-quality feature]. Please tell everyone at [name of company] how happy we are with your product.\r\n<p>\r\nSincerely,\r\n<p>\r\n[name]\r\n[your title]\r\n[company name]\r\n[telephone number]",
  },
  {
    Id: "226121",
    class: "254",

    title: "General Complaint",

    subject: "[product or service received from company]",

    message:
      "Dear [name]:\r\n<p>\r\nI'm writing to inform you of a problem we have had with your company. [description of the problem]. This has caused us some difficulties. [description of problems]. \r\n<p>\r\nWe must resolve this situation quickly. We suggest that you [suggested solution]. Please call me as soon as possible at [telephone number] so that we can discuss our options.\r\n<p>\r\nSincerely,\r\n<p>\r\n[name]\r\n[title]\r\n[company name]\r\n[telephone number]",

    ref1: "5,13,6,4,60266",
  },
  {
    Id: "226122",
    class: "254",

    title: "Complaint about a Problem with a Product",

    subject: "Order [order number]",

    message:
      "Dear [name]:\r\n<p>\r\nOn [date], we ordered [description of goods] from your company. When the shipment arrived on [date], we found a serious problem. [sentence describing problem] \r\n<p>\r\nWe must resolve this quickly. Please call me as soon as possible at [telephone number] so that we can discuss our options.\r\n<p>\r\nSincerely,\r\n<p>\r\n[name]\r\n[title]\r\n[company name]\r\n[telephone number]",

    ref1: "5,13,6,4,60266",
  },
  {
    Id: "226123",
    class: "254",

    title: "Complaint about an Overcharge to an Account",

    subject: "[product or service]",

    message:
      "Dear [name]:\r\n<p>\r\nWe recently purchased [product or service] from your company. When we received our invoice, we noticed that we had been overcharged. When we agreed to this purchase, we were told that it would cost [expected price]. On the invoice, however, we were charged [price charged].\r\n<p>\r\nWe need to address this error quickly. Please call me as soon as possible at [telephone number] to discuss our options.\r\n<p>	\r\nSincerely,\r\n<p>\r\n[name]\r\n[title]\r\n[company name]\r\n[telephone number]",

    ref1: "5,13,6,4,60266",
  },
  {
    Id: "226124",
    class: "254",

    title: "Announcement of a New Product",

    subject: "Addition to Our Product Line",

    message:
      "Dear Customers:\r\n<p>\r\nWe are pleased to announce a new item in our product line. It is [product name here]. This is a significant addition because [positive characteristics of new product]. A complete description is below.\r\n<p>\r\n[name of product]\r\n[product specifications]\r\n[photo, if appropriate]\r\n<p>\r\nWe look forward to talking with you about [product name here]. Please call us at [telephone number here] or reply to this email to arrange for a meeting.\r\n<p>\r\nSincerely,\r\n<p>\r\n[name]\r\n[title]\r\n[company name]\r\n[telephone number]",

    ref1: "4,9,3,4,40184",
  },
  {
    Id: "226125",
    class: "254",

    title: "Announcement of a New Area Representative",

    subject: "Our New Representative in Your Area.",

    message:
      "Dear [name]:\r\n<p>\r\nWe are pleased to announce that [representative's name] will now be representing [company] in your area. [sentence describing new representative's background and experience]. \r\n<p>\r\n[representative's name] will contact you soon to arrange an introductory meeting. We look forward to continuing our successful relationship with you.\r\n<p>\r\nSincerely,\r\n<p>\r\n[name]\r\n[title]\r\n[company name]\r\n[telephone number]",
  },
  {
    Id: "226126",
    class: "254",

    title: "New Product Demo",

    subject: "Product Demo for [new product]",

    message:
      "Dear [name ]:\r\n<p>\r\n[company] will be giving a demonstration for our new product, [product name], on [date] at [time] at [location]. We hope that you will be able to take time out from your busy schedule to attend this exciting event. We believe that this product has several benefits for you:\r\n<p>\r\n[first benefit]\r\n[second benefit]\r\n[third benefit]\r\n<p>\r\nPlease contact me at [telephone number] or reply to this email if you are able to attend.\r\n<p>\r\nSincerely,\r\n<p>\r\n[name]\r\n[title]\r\n[company name]\r\n[telephone number]",
  },
  {
    Id: "226127",
    class: "254",

    title: "Change of Billing Address",

    subject: "Change of Address for [person or company]",

    message:
      "Dear [name]:\r\n<p>\r\nPlease change the billing address for [name]. The new address is below:\r\n<p>\r\n[new address]\r\n<p>\r\nPlease contact me if you have any questions or need additional information.\r\n<p>\r\nSincerely,\r\n<p>\r\n[name]\r\n[title]\r\n[company name]\r\n[telephone number]",
  },
  {
    Id: "226128",
    class: "254",

    title: "Follow-Up after a First Sales Meeting",

    subject: "Our Meeting on [date]",

    message:
      "Dear [name]:\r\n<p>\r\nThank you for taking the time to meet with me. I was interested to learn [describe what customer said]. I found our meeting valuable and hope that we will continue the discussion soon. Are you available on [date] at [time] for a follow-up meeting?\r\n<p>\r\nSincerely,\r\n<p>\r\n[name]<br>\r\n[title]<br>\r\n[company name]<br>\r\n[telephone number]",
  },
  {
    Id: "226129",
    class: "254",

    title: "New Customer Welcome",

    subject: "Welcome!",

    message:
      "Dear [name]:\r\n<p>\r\n[company] is pleased to welcome you as a new customer. We know that you will be satisfied with our products and customer service. If you have any questions about our company, please do not hesitate to contact me at [telephone number] or [email address]. \r\n<p>\r\nOnce again, welcome to [company]!\r\n<p>\r\nSincerely,\r\n<p>\r\n[name]\r\n[title]\r\n[company name]\r\n[telephone number]",
  },
  {
    Id: "226130",
    class: "254",

    title: "Holiday Message to Stockholders or Customers",

    subject: "Happy Holidays!",

    message:
      "Dear [name]:\r\n<p>\r\nHappy holidays! We would like to thank you for your support of [company] throughout this past year. Please accept our warmest wishes for you and your family during this holiday season.  \r\n<p>\r\nSincerely,\r\n<p>\r\n[company]",
  },
  {
    Id: "226131",
    class: "254",

    title: "Suspended Account",

    subject: "Your Account with [company]",

    message:
      "Dear [name of customer]:\r\n<p>\r\nWe regret to inform you that we are closing your account with [company] because [reason for closing the account]. \r\n<p>\r\nIf you would like to discuss this matter, please contact [name] at [telephone number].\r\n<p>\r\nSincerely,\r\n<p>\r\n[name]\r\n[title]\r\n[your company's name]\r\n[your telephone number]",
  },
  {
    Id: "226132",
    class: "254",

    title: "Request to Close an Account",

    subject: "Account Number [your account number]",

    message:
      "Dear [name]:\r\n<p>\r\nThis is to inform you that I am closing my account with [name of company]. Please confirm that you have received this email, and please notify me when my account has been closed. You can contact me if you have any questions or if you need additional information.\r\n<p>	\r\nSincerely,\r\n<p>\r\n[name]",
  },
  {
    Id: "226133",
    class: "254",

    title: "Acknowledgment of Receipt of Application",

    subject: "Your Application for [job title] at [company name]",

    message:
      "Dear [name]:\r\n<p>\r\nThis to confirm that we have received your application for [job title]. We will review your qualifications carefully and will notify you if we have any questions or if we would like to schedule an interview.\r\n<p>\r\nThank you for your interest in [company name]!\r\n<p>\r\n[name]\r\n[job title]\r\n[company name]\r\n[telephone number]",
  },
  {
    Id: "226134",
    class: "254",

    title: "General Thanks",

    subject: "Thank You!",

    message:
      "Dear [name]:\r\n<p>\r\nI just wanted to thank you for [description of what person did]. I really appreciate it!\r\n<p>\r\nSincerely,\r\n<p>\r\n[name]",

    ref1: "3,10,5,4,40705",
  },
];

/* EO EMAIL TEMPLATE, CULTURE NOTES and ACCENTS AND DIALECTS data*/

export {
  productList,
  monthList,
  tmsProductIds,
  progressPageIds,
  orderedDemoLicensesIds,
  LOCALES,
  termsOfUse,
  onboardingVideoUrls,
  badgeRange,
  scheduleCourseStatus,
  activeStatus,
  AccentsAndDialectsDD,
  cultureNotesDD,
  cultureNotesTopicDD,
  EmailTemplateDD,
  TemplateMapper,
  Templates,
  allEnglishProductIds,
  dynamicCardProducts,
  dashboardProductIds,
  demoLicenseUserId,
  allProducts,
  soloProducts,
  soloProductsMapper,
  twtLicenseMapper,
  sprintBusinessProducts,
  soloProductIdMap,
  twtSessionsDays,
};
